<template>
    <div class="container mt-5">
        <router-view />
    </div>
</template>

<script>
export default {
    
};
</script>